import React, { useEffect, useState } from 'react';

import client from '../api/client';
import { API_BASE } from '../api/config';

// Debug page — pings GET /api/v2/health to confirm the new client can reach
// the new server namespace. Not part of the storefront; Phase 0 smoke test.
export default function Health() {
  const [state, setState] = useState({ status: 'loading', data: null, error: null });

  useEffect(() => {
    let active = true;
    client
      .get('/health')
      .then((res) => {
        if (active) setState({ status: 'ok', data: res.data, error: null });
      })
      .catch((err) => {
        if (active) {
          setState({ status: 'error', data: null, error: err.message || String(err) });
        }
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <section className="ss-container" style={{ paddingBlock: 'var(--ss-space-6)' }}>
      <h1>v2 health check</h1>
      <p style={{ color: 'var(--ss-brown-hover)' }}>
        Pinging <code>{`${API_BASE}/health`}</code>
      </p>

      <div className="ss-card" style={{ marginTop: 'var(--ss-space-4)' }}>
        {state.status === 'loading' && <p>Checking…</p>}
        {state.status === 'ok' && (
          <>
            <p style={{ color: 'var(--ss-green-deep)', fontWeight: 600 }}>✓ Healthy</p>
            <pre style={{ overflowX: 'auto' }}>{JSON.stringify(state.data, null, 2)}</pre>
          </>
        )}
        {state.status === 'error' && (
          <p style={{ color: 'var(--ss-error)', fontWeight: 600 }}>✗ {state.error}</p>
        )}
      </div>
    </section>
  );
}
